import { render, staticRenderFns } from "./nav_m.vue?vue&type=template&id=04476cda"
import script from "./nav_m.vue?vue&type=script&lang=js"
export * from "./nav_m.vue?vue&type=script&lang=js"
import style0 from "./nav_m.vue?vue&type=style&index=0&id=04476cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports